import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { DocModel } from '@smarttask-common/src/lib/models/Record/Doc/Core/DocModel';

export enum DocActionTypes {
    ADD_DOC = '[Doc] Add Doc',
    UPSERT_DOC = '[Doc] Upsert Doc',
    ADD_DOCS = '[Doc] Add Docs',
    UPSERT_DOCS = '[Doc] Upsert Docs',
    UPDATE_DOC = '[Doc] Update Doc',
    UPDATE_DOCS = '[Doc] Update Docs',
    DELETE_DOC = '[Doc] Delete Doc',
    DELETE_DOCS = '[Doc] Delete Docs',
    DELETE_STATE = '[Doc] Delete State',

    UPDATE_SELECTED_ID = '[Doc] Update SelectedId',
}

export class UpdateSelectedDocId implements Action {
    readonly type = DocActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_record_id: string) {}
}

export class AddOne implements Action {
    readonly type = DocActionTypes.ADD_DOC;
    constructor(public doc: DocModel) {}
}

export class AddMany implements Action {
    readonly type = DocActionTypes.ADD_DOCS;
    constructor(public docs: Array<DocModel>) {}
}

export class UpsertOne implements Action {
    readonly type = DocActionTypes.UPSERT_DOC;
    constructor(public doc: DocModel) {}
}

export class UpsertMany implements Action {
    readonly type = DocActionTypes.UPSERT_DOCS;
    constructor(public docs: Array<DocModel>) {}
}

export class UpdateOne implements Action {
    readonly type = DocActionTypes.UPDATE_DOC;
    constructor(
        public id: string,
        public changes: Partial<DocModel>,
    ) {}
}

export class UpdateMany implements Action {
    readonly type = DocActionTypes.UPDATE_DOCS;
    constructor(public updates: Array<Update<DocModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = DocActionTypes.DELETE_DOC;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = DocActionTypes.DELETE_DOCS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = DocActionTypes.DELETE_STATE;
    constructor() {}
}

export type DocActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedDocId;
